import { useMenu } from 'src/contexts/menu-context'
import type { NextLevelProps } from '../../../global-navigation'
import { getSearchedItems, trackMenuPath } from '../../../utils'

type AlphabeticalMenuItemsProp = NextLevelProps & {
  query: string
}

export const AlphabeticalMenuItems = ({
  menu,
  query,
}: AlphabeticalMenuItemsProp) => {
  const filteredMenu = getSearchedItems(query, menu)
  const { state } = useMenu()

  return (
    <>
      {Object.keys(filteredMenu)?.map((el) => (
        <div key={`alphabetical-letter-${el}`}>
          <div
            className="h-9 w-9 p-2 rounded-lg flex items-center justify-center mb-2"
            style={{ backgroundColor: '#EFEFEF' }}
          >
            <span className="block text-[#0F0F13] !leading-[20px] text-sm font-normal">
              {el}
            </span>
          </div>
          {filteredMenu[el]?.map((item) => (
            <div className="py-2" key={`alphabetical-item-${item.label}`}>
              <a
                onClick={() => trackMenuPath(state, item.label)}
                className="text-sm font-semibold tracking-[0.035px] text-[#535353] flex flex-row justify-between items-center no-underline"
                href={item.url ? item.url : undefined}
              >
                <span className="block">{item.label}</span>
              </a>
            </div>
          ))}
        </div>
      ))}
    </>
  )
}
